// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfilePdfPackCard-cls1_SCf","cls2":"ProfilePdfPackCard-cls2_Blv ProfilePdfPackCard-cls1_SCf"};